<style>
  #MyListMenu li {
    list-style: none;
  }

  .Lvl2 {
    margin: 10px 20px;
  }
</style>

<div class="card card-statistics mb-30">
  <div class="card-body">
    <h5 class="card-title">Edit User '{{FullName}}'</h5>
    <form [formGroup]="EditUser" (submit)="SubmitEditUser()">

      <input type="hidden" formControlName="id" />

      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Password (only when setting a new password) </label>
          <input formControlName="Password" type="text" class="form-control" placeholder="Type here...">
          <small *ngIf="!get_Form_Password().valid && get_Form_Password().touched"
            class="form-text text-muted MyErrorRedColor">Enter a password of at least 6 characters.</small>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Type User </label>
          <select formControlName="Type" class="custom-select">
            <option value="0">Select</option>
            <option value="1">Administrator</option>
            <option value="2">Standard User</option>
          </select>
        </div>

        <div class="form-group col-md-4" *ngIf="get_Form_Type().value!='1'">
          <label for="exampleInputEmail1"> Calibration Data Access </label>
          <select formControlName="ExpertCalibration" class="custom-select">
            <option value="0">Assigned Data</option>
            <option value="1">All Data</option>
          </select>
        </div>
        <div class="form-group col-md-4" *ngIf="get_Form_Type().value=='1'">
          <label for="exampleInputEmail1"> Calibration Data Access </label>
          <p>All Data</p>
        </div>
      </div>

 

      <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
      <button *ngIf="!InProccessing" type="submit" [disabled]="!EditUser.valid" class="btn btn-success"
        style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Save </button>
      <button routerLink="/User" *ngIf="!InProccessing" type="button" class="btn btn-warning"><i
          class="fa fa-mail-reply"></i> Back </button>
    </form>
  </div>
</div>
